import { normalizePriority } from '../../utils/signalLevels';

export const normalizeKnowledgeGap = (gap = {}, index = 0) => {
  const topicId = gap.topic_id || gap.id || `gap-${index}`;
  return {
    id: String(topicId),
    topic_id: String(topicId),
    topic: gap.topic || 'Unknown Topic',
    description: gap.description || '',
    priority: normalizePriority(gap.priority),
    status: gap.status || 'identified',
    query_count: gap.query_count || 0,
    agent_name: gap.agent_name || '',
    agents: gap.agents || [gap.agent_name].filter(Boolean),
    sample_queries: gap.sample_queries || [],
    queries: gap.queries || gap.prompts || gap.members || [],
    member_interaction_ids: gap.member_interaction_ids || [],
    drilldown_filter: gap.drilldown_filter || null,
    is_noise: Boolean(gap.is_noise),
    ungrounded_segments: gap.ungrounded_segments || [],
    last_seen: gap.last_seen || '',
    gap_type: gap.gap_type || null,
    suggested_action: gap.suggested_action || null,
    users_affected: gap.users_affected || 0,
    estimated_hours_lost: gap.estimated_hours_lost ?? null,
    estimated_cost_impact: gap.estimated_cost_impact ?? null,
    cost_excluded: Boolean(gap.cost_excluded),
  };
};
